
import { ref } from "@vue/reactivity";
import {useStore} from "vuex";
import Dialog from "primevue/dialog";
import router from '@/router';
import { computed} from '@vue/runtime-core';
import '../../assets/sass/components/DueDiligence/_popUpRenovacionDebidaDiligencia.scss';

export default {
name: 'PopUpRenovacionDebidaDiligencia',
components: {
    Dialog,
},
props: {
  estadoDD: Number
},
setup() {     
      const store= useStore();
      const UrlDebidaDiligencia = ref();
      const sinSalidaDePlans = computed(() => {
        return localStorage.getItem("DatosContactoRedireccion") === "Plans"
      });

      store.dispatch('obtenerUrlDebidaDiligencia').then((response) => 
      {
        UrlDebidaDiligencia.value = response;
      });

      const CerrarModal = () => {
      router.push('Transmission')
    };
       
    return {
      store,
      UrlDebidaDiligencia,
      CerrarModal,
      sinSalidaDePlans
    };
  },   
};
